import { RmsUserManagementService } from './rms-user-management.service';
import { RoleConstants } from './role.constants';
import { NgModule } from '@angular/core';
import { RmsAccessService } from './rms-access.service';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from '../../app-routing.module';
import { ApiModule } from '../../api/api.module';
import { CoreModule } from '../../../../shared/core/core.module';
import { RespondersService } from './responders.service';
import { TeamsService } from './teams.service';
import {AuthApiService} from "./auth.service";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {RmsAuthRequestInterceptor} from "./rms-auth-request.interceptor";
import {RmsResponseRecordsCountInterceptor} from "./rms-response-records-count.interceptor";
import { RmsResponseDomainErrorsInterceptor } from"./rms-response-domain-error.interceptor";
import { RmsPolicyPermissionsService } from './rms-policy-permissions.service';
import { RmsPolicyPermissionsGuard } from './rms-policy-permissions.guard';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    ApiModule,
    AppRoutingModule
  ],
  declarations: [],

  providers: [
    AuthApiService,
    RespondersService,
    TeamsService,
    RmsUserManagementService,
    RmsAccessService,
    RmsPolicyPermissionsService,
    RmsPolicyPermissionsGuard,
    RoleConstants,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RmsAuthRequestInterceptor,
      multi: true
    },
    RoleConstants,
    {
      provide: HTTP_INTERCEPTORS,
      useClass:  RmsResponseRecordsCountInterceptor,
      multi: true
    },
    RoleConstants,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RmsResponseDomainErrorsInterceptor,
      multi: true
    }
  ],exports:[]
})
export class CoreRmsModule { }
